import React from 'react';

/**
 * Découpe un texte en mots animables (chaque mot monte depuis un masque).
 * Le texte reste lisible par les lecteurs d'écran via aria-label.
 */
const SplitText = ({ text, as: Tag = 'span', className = '', delay = 0, step = 55 }) => (
  <Tag className={`split ${className}`} aria-label={text}>
    {text.split(' ').map((word, i) => (
      <span className="split-mask" key={`${word}-${i}`} aria-hidden="true">
        <span className="split-word" style={{ animationDelay: `${delay + i * step}ms` }}>
          {word}
        </span>
      </span>
    ))}
  </Tag>
);

export default SplitText;
